import { AccessorialData, AccessorialUnitOfMeasureData, ShipperAccessorialData } from '.';

export interface ShipperAccessorialDetailData extends ShipperAccessorialData {
  accessorial: AccessorialData;
  accessorialUnitOfMeasure: AccessorialUnitOfMeasureData;
}
